module.exports = __webpack_public_path__ + "static/img/16.872808c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/6/16.jpg
// module id = 776
// module chunks = 0